var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,945.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 62 62 m 189.875 17.179 l -189.875 -17.179 l 18.083 189.875 c 0 9.946 8.137 18.083 18.083 18.083 h 171.792 v -172.696 c 0 -9.946 -8.137 -18.083 -18.083 -18.083 z m -9.494 163.202 h -121.61 c -7.233 0 -13.11 -5.877 -13.11 -13.11 l -9.946 -131.104 l 131.556 9.494 c 7.233 0 13.11 5.877 13.11 13.02 v 121.701 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 124 124 m 68.355 0 l 0 0 c -6.51 0 -12.821 2.591 -17.471 7.241 l -4.384 4.384 l -4.384 -4.384 c -4.65 -4.65 -10.894 -7.241 -17.471 -7.241 h 0 c -13.618 0 -24.645 11.027 -24.645 24.645 v 0 c 0 6.51 2.591 12.821 7.241 17.404 l 4.384 4.451 l -4.384 4.384 c -4.65 4.65 -7.241 10.894 -7.241 17.471 v 0 c 0 13.618 11.027 24.645 24.645 24.645 h 0 c 6.51 0 12.821 -2.591 17.404 -7.241 l 4.451 -4.384 l 4.384 4.384 c 4.65 4.65 10.894 7.241 17.404 7.241 h 0 c 13.618 0 24.645 -11.027 24.645 -24.645 v 0 c 0 -6.51 -2.591 -12.821 -7.241 -17.404 l -4.318 -4.451 l 4.384 -4.384 c 4.65 -4.65 7.241 -10.894 7.241 -17.471 v 0 c 0 -13.618 -11.027 -24.645 -24.645 -24.645 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 744 62 m 189.875 17.179 l -189.875 -17.179 l 18.083 189.875 c 0 9.946 8.137 18.083 18.083 18.083 h 171.792 v -172.696 c 0 -9.946 -8.137 -18.083 -18.083 -18.083 z m -9.494 163.202 h -121.61 c -7.233 0 -13.11 -5.877 -13.11 -13.11 l -9.946 -131.104 l 131.556 9.494 c 7.233 0 13.11 5.877 13.11 13.02 v 121.701 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 806 124 m 68.355 0 l 0 0 c -6.51 0 -12.821 2.591 -17.471 7.241 l -4.384 4.384 l -4.384 -4.384 c -4.65 -4.65 -10.894 -7.241 -17.471 -7.241 h 0 c -13.618 0 -24.645 11.027 -24.645 24.645 v 0 c 0 6.51 2.591 12.821 7.241 17.404 l 4.384 4.451 l -4.384 4.384 c -4.65 4.65 -7.241 10.894 -7.241 17.471 v 0 c 0 13.618 11.027 24.645 24.645 24.645 h 0 c 6.51 0 12.821 -2.591 17.404 -7.241 l 4.451 -4.384 l 4.384 4.384 c 4.65 4.65 10.894 7.241 17.404 7.241 h 0 c 13.618 0 24.645 -11.027 24.645 -24.645 v 0 c 0 -6.51 -2.591 -12.821 -7.241 -17.404 l -4.318 -4.451 l 4.384 -4.384 c 4.65 -4.65 7.241 -10.894 7.241 -17.471 v 0 c 0 -13.618 -11.027 -24.645 -24.645 -24.645 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 62 744 m 189.875 17.179 l -189.875 -17.179 l 18.083 189.875 c 0 9.946 8.137 18.083 18.083 18.083 h 171.792 v -172.696 c 0 -9.946 -8.137 -18.083 -18.083 -18.083 z m -9.494 163.202 h -121.61 c -7.233 0 -13.11 -5.877 -13.11 -13.11 l -9.946 -131.104 l 131.556 9.494 c 7.233 0 13.11 5.877 13.11 13.02 v 121.701 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 124 806 m 68.355 0 l 0 0 c -6.51 0 -12.821 2.591 -17.471 7.241 l -4.384 4.384 l -4.384 -4.384 c -4.65 -4.65 -10.894 -7.241 -17.471 -7.241 h 0 c -13.618 0 -24.645 11.027 -24.645 24.645 v 0 c 0 6.51 2.591 12.821 7.241 17.404 l 4.384 4.451 l -4.384 4.384 c -4.65 4.65 -7.241 10.894 -7.241 17.471 v 0 c 0 13.618 11.027 24.645 24.645 24.645 h 0 c 6.51 0 12.821 -2.591 17.404 -7.241 l 4.451 -4.384 l 4.384 4.384 c 4.65 4.65 10.894 7.241 17.404 7.241 h 0 c 13.618 0 24.645 -11.027 24.645 -24.645 v 0 c 0 -6.51 -2.591 -12.821 -7.241 -17.404 l -4.318 -4.451 l 4.384 -4.384 c 4.65 -4.65 7.241 -10.894 7.241 -17.471 v 0 c 0 -13.618 -11.027 -24.645 -24.645 -24.645 z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    height: 899,
    width: 899,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 62,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 124,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 744,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 806,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.807c61f4c105789539c98e4042147331.svg";
export { ForwardRef as ReactComponent };